import { MenuItem } from "@mui/material";
import { MenuItemDef, IMenuActionParams } from "ag-grid-enterprise";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { updateOrderUATStatus } from "../../../config/axios/apis/order/order";
import { success } from "../../../utils/AppUtils";
import store from "../../../store";
import { uiActions } from "../../../reducers/uiReducer";

interface IProps {
    selectedRows: any[];
    action: VoidFunction;
}

const UATOrderActions = {
    setUat: (selectedItems) =>
        ({
            name: "Set as UAT",

            action: () => {
                const setIds = selectedItems.map((item) => item.id);

                return updateOrderUATStatus({ idsToSet: setIds, idsToUnset: [] }, {}, true).then(() => {
                    store.dispatch(uiActions.setForceRefreshGrid(true));
                    success(<FormattedMessage id="grid.message.uat-status-updated" defaultMessage="Updated UAT status" />);
                });
            },
        }) as MenuItemDef,
    removeUat: (selectedItems) =>
        ({
            name: "Set as not UAT",

            action: () => {
                const setIds = selectedItems.map((item) => item.id);

                return updateOrderUATStatus({ idsToSet: [], idsToUnset: setIds }, {}, true).then(() => {
                    store.dispatch(uiActions.setForceRefreshGrid(true));
                    success(<FormattedMessage id="grid.message.uat-status-updated" defaultMessage="Updated UAT status" />);
                });
            },
        }) as MenuItemDef,
};

export const getUATMenuItemsDefinition = (selectedRows: any[]): MenuItemDef[] => {
    const UATOrders = selectedRows.filter((e) => e?.isUat === true);
    const regularOrders = selectedRows.filter((e) => e?.isUat === false);

    if (UATOrders.length !== 0 && UATOrders.length === selectedRows.length) {
        return [UATOrderActions.removeUat(UATOrders)];
    }

    if (regularOrders.length !== 0 && regularOrders.length === selectedRows.length) {
        return [UATOrderActions.setUat(regularOrders)];
    }

    return [];
};

export const GetUATMenuItemNodes: FC<IProps> = ({ selectedRows, action }) => {
    const UATOrders = selectedRows.filter((e) => e?.isUat === true);
    const regularOrders = selectedRows.filter((e) => e?.isUat === false);

    // dirty fix, params are irrelevant because they are not read. Needed since the same methods are called from the grid RMB click context menu.
    const renderMenuItem = (config: MenuItemDef) => {
        const onClickHandle = () => {
            if (config.action) {
                config.action({} as IMenuActionParams);
            }
            action();
        };
        return <MenuItem onClick={onClickHandle}>{config.name}</MenuItem>;
    };

    if (UATOrders.length !== 0 && UATOrders.length === selectedRows.length) {
        return renderMenuItem(UATOrderActions.removeUat(UATOrders));
    }

    if (regularOrders.length !== 0 && regularOrders.length === selectedRows.length) {
        return renderMenuItem(UATOrderActions.setUat(regularOrders));
    }

    return null;
};
